var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePersonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8346 9.3326C12.0316 9.3326 12.2266 9.37141 12.4086 9.4468C12.5905 9.52219 12.7558 9.63269 12.8951 9.77198C13.0343 9.91128 13.1447 10.0766 13.22 10.2586C13.2953 10.4406 13.3341 10.6357 13.334 10.8326V11.4446C13.3338 11.8267 13.2142 12.1991 12.992 12.5099C11.962 13.9526 10.2786 14.6666 7.99864 14.6666C5.71797 14.6666 4.03597 13.9519 3.00797 12.5093C2.78672 12.1986 2.66787 11.8267 2.66797 11.4453V10.8319C2.66797 10.4345 2.82575 10.0534 3.10664 9.77222C3.38753 9.49108 3.76855 9.33296 4.16597 9.3326H11.834H11.8346ZM7.99864 1.33594C8.43638 1.33594 8.86983 1.42216 9.27425 1.58967C9.67867 1.75719 10.0461 2.00272 10.3557 2.31225C10.6652 2.62178 10.9107 2.98924 11.0782 3.39366C11.2458 3.79808 11.332 4.23153 11.332 4.66927C11.332 5.10701 11.2458 5.54046 11.0782 5.94488C10.9107 6.3493 10.6652 6.71676 10.3557 7.02629C10.0461 7.33582 9.67867 7.58135 9.27425 7.74887C8.86983 7.91638 8.43638 8.0026 7.99864 8.0026C7.11458 8.0026 6.26673 7.65141 5.64161 7.02629C5.01649 6.40117 4.6653 5.55333 4.6653 4.66927C4.6653 3.78522 5.01649 2.93737 5.64161 2.31225C6.26673 1.68713 7.11458 1.33594 7.99864 1.33594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePersonLogo);
export default __webpack_public_path__ + "static/media/profilePersonLogo.24fcf9758585f93315a0a2234d4be208.svg";
export { ForwardRef as ReactComponent };